import React from 'react';

import {StandardModelViewerRecordRenderer} from "../RecordRenderers/StandardModelViewerRecordRenderer";

export const FileUploadTagModelViewerRecordRenderer = props => {

    const {Data, EditMode} = props;
    const overrideEditMode = !Data?.isAssigned && EditMode;

    return <StandardModelViewerRecordRenderer
        {...props}
        EditMode={overrideEditMode}
    />
};


